import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { PagedResponse } from "../../types/Result";
import { SystemChat } from "../systemChat/type";

export const systemChatListlaoderLastUnRead: LoaderFunction = async (args) => {
  let url = new URL(args.request.url);
  const result = await axiosApi.get<PagedResponse<SystemChat>>(
    "/api/systemChats?pageNumber=0&pageSize=10&sort.sort=desc&sort.field=creationTime&filters[0].field=isRead&filters[0].operator=is&filters[0].value=false"
  );
  const statistic = await axiosApi.get("/api/systemLogs/statistic/");
  return { logData: result.data, statistic: statistic.data };
};
